import { objectWithoutProperties as _objectWithoutProperties, objectSpread as _objectSpread, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import styled from 'styled-components';
import { appendToUrl } from '../../utilities/searchParameters/index.js';
import { defaultStyles, hoverStyles, focusStyles } from './setLinkStyles.js';
import { NicolletContextConsumer as Consumer } from '../NicolletContext/NicolletContext.js';

var Link = function Link(props) {
  var _props$href = props.href,
      href = _props$href === void 0 ? '#' : _props$href,
      color = props.color,
      underline = props.underline,
      onClick = props.onClick,
      children = props.children,
      childRef = props.childRef,
      innerRef = props.innerRef,
      disableMode = props.disableMode,
      className = props.className,
      target = props.target,
      isButton = props.isButton,
      noHoverColor = props.noHoverColor,
      restPropsConst = _objectWithoutProperties(props, ["href", "color", "underline", "onClick", "children", "childRef", "innerRef", "disableMode", "className", "target", "isButton", "noHoverColor"]);

  var _restPropsConst$refre = restPropsConst.refresh,
      refresh = _restPropsConst$refre === void 0 ? false : _restPropsConst$refre,
      restProps = _objectWithoutProperties(restPropsConst, ["refresh"]); // regular anchor tag if no routing required (href = #) for optimization.
  // regular anchor tag if absolute url starting with protocol example http:


  var isAnchor = href.match(/^(#|tel:|mailto:|http)/);

  var linkOnClick = function linkOnClick(e) {
    if (onClick) {
      // TODO: This is a hacky check used by the Navigation to allow us to
      // bypass routing if we have childNodes being returned
      // This should be removed once we start navigating to category pages
      // or once we add a config for routing
      var returnedVal = onClick(e);
      if (returnedVal) return returnedVal;
    }

    return true;
  };

  var anchorProps = _objectSpread({
    href: href,
    className: className,
    onClick: linkOnClick,
    ref: childRef || innerRef,
    target: target
  }, restProps);

  var Element = isButton ? 'button' : 'a';
  return React.createElement(Consumer, null, function () {
    var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _context$nicollet = context.nicollet,
        nicollet = _context$nicollet === void 0 ? {} : _context$nicollet;
    var mode = nicollet.mode,
        _nicollet$RouterLink = nicollet.RouterLink,
        RouterLink = _nicollet$RouterLink === void 0 ? 'a' : _nicollet$RouterLink; // When we have a mode, and we're disabling mode on this link,
    // we should do a hard refresh to be sure we're routed via Akamai again back to the old stack.
    // TODO: Remove once we're fully on React stack, not just with Restock/box mode.

    if (!isAnchor && mode && disableMode) {
      refresh = true;
    }

    var skipMode = isAnchor || disableMode || !mode;
    var modeHref = skipMode ? href : appendToUrl(href, {
      mode: mode
    }, {
      replace: false // don't replace existing mode so links can reset e.g. with "mode="

    });
    return !isAnchor && !refresh && RouterLink ? React.createElement(RouterLink, _extends({}, anchorProps, {
      to: modeHref,
      href: modeHref
    }), children) : React.createElement(Element, _extends({}, anchorProps, {
      href: modeHref
    }), children);
  });
};

Link.displayName = 'Link';
var StyledLink = styled(Link).withConfig({
  displayName: "Link__StyledLink",
  componentId: "i21edc-0"
})(["", ";", ";", ";"], defaultStyles, hoverStyles, focusStyles);
StyledLink.displayName = 'Link';
StyledLink.defaultProps = {
  color: 'onLight',
  isButton: false,
  underline: 'default',
  noHoverColor: false
};

export default StyledLink;
export { StyledLink as Link };
